<template>
  <div class="recommend-container">
    <!-- 轮播图 -->
    <Swiper
      v-if="imgList.length > 0"
      :imgList="imgList"
      :duration="2000"
    ></Swiper>
    <!-- 热文卡片 -->
    <!-- <div
      class="card-main"
      v-if="encyclopediasList.length > 0 || familyList.length > 0"
    >
      <Card :cardList="familyList" title="百家热点文章" moreUrl="/bjzx"></Card>
      <Card
        :cardList="encyclopediasList"
        title="百科热点文章"
        moreUrl="/bkzx"
      ></Card>
    </div> -->
    <!-- <div v-for="(item, i) in listTest" :key="i">
      <div class="group-content" v-for="(v, i) in item.xxx" :key="i">
        <Item
          v-for="item in v.itemList"
          :key="item.id"
          :curcer="item.id"
          :every="item"
          @itemClick="goDetail"
        ></Item>
        <div class="column-main" v-if="v.columnList && v.columnList.length > 0">
          <Column
            v-for="item in v.columnList"
            :key="item.id"
            :column="item"
          ></Column>
        </div>
      </div>
    </div> -->
    <div class="group-content" v-for="(v, i) in rowList" :key="i">
      <!-- 详情 -->
      <Item
        v-for="item in v.itemList"
        :key="item.id"
        :curcer="item.id"
        :every="item"
        @itemClick="goDetail"
      ></Item>
      <!-- 科技卡片 -->
      <div class="column-main" v-if="v.columnList && v.columnList.length > 0">
        <Column
          v-for="item in v.columnList"
          :key="item.id"
          :column="item"
        ></Column>
      </div>
    </div>
    <!-- 学者入驻指南 -->
    <!-- <div class="banner-img">
      <img v-lazy="require('@/assets/img/qietu/学者.png')" alt="" />
    </div>
    <div class="column-main">
      <Column
        v-for="item in scholarList"
        :key="item.id"
        :column="item"
      ></Column>
    </div> -->
    <!-- 加载更多 -->
    <div class="load-more" @click="loadClick">
      <div>{{ moreLoad }}</div>
    </div>
    <!-- 百家号 -->
    <HundredNumber
      :hundredNum="numList[0]"
      moreUrl="/bjzx"
      v-if="numList[0].itemList.length > 0"
      @goBjDetails="bjDetails"
    ></HundredNumber>
    <!-- 百科号 -->
    <HundredNumber
      :hundredNum="numList[1]"
      moreUrl="/bkzx"
      v-if="numList[1].itemList.length > 0"
      @goBjDetails="bkDetails"
    ></HundredNumber>
  </div>
</template>

<script>
import Swiper from "@/components/swiper";
// import Card from "./components/Card";
import Item from "@/components/pager/Item";
import Column from "./components/Column";
import HundredNumber from "./components/HundredNumber";
export default {
  components: {
    Swiper,
    // Card,
    Item,
    Column,
    HundredNumber,
  },
  data() {
    return {
      moreLoad: "点击加载更多",
      imgList: [
        //   模拟数据
        // "https://tse1-mm.cn.bing.net/th?id=OIP.M2dHJdmuNPhuODWuMLIK_gHaEo&w=177&h=110&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
        // "https://tse1-mm.cn.bing.net/th?id=OIP.T1-KOJxH7Dg0YqlcZiJ6vAHaHa&w=111&h=110&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
        // "https://tse1-mm.cn.bing.net/th?id=OIP.M2dHJdmuNPhuODWuMLIK_gHaEo&w=177&h=110&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
        // "https://tse1-mm.cn.bing.net/th?id=OIP.T1-KOJxH7Dg0YqlcZiJ6vAHaHa&w=111&h=110&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
        // "https://tse1-mm.cn.bing.net/th?id=OIP.M2dHJdmuNPhuODWuMLIK_gHaEo&w=177&h=110&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2",
      ],
      encyclopediasList: [],
      familyList: [],
      cardList: [
        {
          src: require("@/assets/img/qietu/1.png"),
          title: "武汉市发布2020知识产权发展状况白皮书",
          isHot: true,
          type: "体育科学",
          count: 23698,
        },
        {
          src: require("@/assets/img/qietu/2.png"),
          title:
            "武汉市发布2020知识产权发展状况白皮书专家说：空腹不宜吃饭发接收到",
          isHot: false,
          type: "体育科学",
          count: 23698,
        },
        {
          src: require("@/assets/img/qietu/3.png"),
          title: "专家视角：如何推动学校国防教育工作高",
          isHot: false,
          type: "体育科学",
          count: 23698,
        },
        {
          src: require("@/assets/img/qietu/4.png"),
          title: "美日将共同开发6g移动通信技术",
          isHot: true,
          type: "体育科学",
          count: 23698,
        },
        {
          src: require("@/assets/img/qietu/5.png"),
          title: "武汉市发布2020知识产权发展状况白皮书",
          isHot: false,
          type: "体育科学",
          count: 23698,
        },
      ],
      numList: [
        {
          title: "百家号",
          new: "最新入驻",
          itemList: [],
        },
        {
          title: "百科号",
          new: "最新入驻",
          itemList: [],
        },
      ],
      curNumItem: 1, // item 第一页
      curNumColumn: 1, // 推荐第一页
      rowList: [],
      flag: true,
      listTest: [],
      pageNumTest: 4,
    };
  },
  created() {
    this.getBannerList(); // 轮播图
    this.testItem(1, 2);
    this.getFamilyList(); // 百家号
    this.getSectionList(); // 百科号
    this.getHotEncyclopediasList({
      pageSize: 5,
    }); // 百科热门
    this.getHotFamilyList({
      pageSize: 5,
    }); // 百家热门
  },
  methods: {
    async testItem(start, end) {
      for (let i = start; i <= end; i++) {
        const res = await this.$apis.mainServe.getItemList({
          pageNo: this.curNumItem++,
          pageSize: 10,
          articleTypes: "0,5,6,2",
          types: "0,3",
        });
        if (res.data) {
          this.rowList.push({
            itemList: res.data.list,
          });
        }
        const resp = await this.$apis.mainServe.getColumnLists({
          pageNo: this.curNumColumn++,
          pageSize: 3,
        });
        this.rowList.push({
          columnList: resp.page.list,
        });
      }
    },
    async getHotEncyclopediasList(data) {
      const res = await this.$apis.mainServe.getHotEncyclopediasList(data);
      // src: require("@/assets/img/qietu/1.png"),
      this.encyclopediasList = res.data.map((item, index) => {
        if (index + 1 <= 5) {
          return {
            src: require(`@/assets/img/qietu/${index + 1}.png`),
            title: item.title,
            id: item.articleId,
            type: item.articleType,
            scores: item.scores,
            name: item.username,
          };
        } else {
          return {
            title: item.title,
            id: item.articleId,
            type: item.articleType,
            scores: item.scores,
            name: item.username,
          };
        }
      });
    },
    async getHotFamilyList(data) {
      const res = await this.$apis.mainServe.getHotFamilyList(data);
      if (res.data) {
        this.familyList = res.data.map((item, index) => {
          if (index + 1 <= 5) {
            return {
              src: require(`@/assets/img/qietu/${index + 1}.png`),
              title: item.title,
              id: item.articleId,
              type: item.articleType,
              scores: item.scores,
              name: item.username,
            };
          } else {
            return {
              title: item.title,
              id: item.articleId,
              type: item.articleType,
              scores: item.scores,
              name: item.username,
            };
          }
        });
      }
    },
    async getBannerList() {
      const res = await this.$apis.mainServe.getBannerList();
      this.imgList = res.bannerList;
    },
    async getItemList(data) {
      const res = await this.$apis.mainServe.getItemList(data);
      if (res.data) {
        this.rowList.push({
          itemList: res.data.list,
        });
      }
    },
    async getFamilyList() {
      const res = await this.$apis.mainServe.getFamilyList();
      if (res.userList) {
        this.numList[0].itemList = res.userList.list;
      }
    },
    async getSectionList() {
      const res = await this.$apis.mainServe.getSectionList();
      if (res.periodicalList) {
        this.numList[1].itemList = res.periodicalList.list;
      }
    },
    async getColumnList(data) {
      const res = await this.$apis.mainServe.getColumnList(data);
      this.rowList.push({
        columnList: res.data,
      });
    },
    // 加载更多
    async loadClick() {
      this.pageNumTest = this.pageNumTest + 2;
      const resp = await this.$apis.mainServe.getColumnLists({
        pageNo: this.curNumColumn,
        pageSize: 3,
      });
      if (resp.page.list && resp.page.list.length === 0) {
        this.curNumColumn = 1;
      }
      this.testItem(this.pageNumTest, this.pageNumTest + 1);
    },
    handleScroll() {
      const height = document.documentElement.clientHeight;
      const scollTop = document.documentElement.scrollTop;
      if (scollTop > height && this.flag) {
        // 请求接口
        this.getColumnList({
          num: 3,
        });
        this.flag = false;
      }
    },
    // 跳转详情
    goDetail(e) {
      console.log(e);
      let routeUrl;
      if (e.articleType === 0 && e.type === 0) {
        routeUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 0 && e.type === 3) {
        routeUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 6) {
        routeUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 5) {
        routeUrl = this.$router.resolve({
          path: "/msgDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 2) {
        routeUrl = this.$router.resolve({
          path: "/concentrationDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    bjDetails(item) {
      let routeUrl = this.$router.resolve({
        name: "bjzxdetail",
        query: { title: "百家在线", id: item.id },
      });
      window.open(routeUrl.href, "_blank");
    },
    bkDetails(item) {
      let routeUrl = this.$router.resolve({
        name: "bkzxdetail",
        query: { title: "百科在线", id: item.id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-container {
  width:1200px;
  // margin-top: 4px;
  margin:4px auto;
  .card-main {
    display: flex;
    height: 469px;
    margin: 15px 0 6px 0;
    justify-content: space-between;
  }
  .column-main {
    display: flex;
    margin: 6px 0;
  }
  .banner-img {
    width: 100%;
    height: 227px;
    overflow: hidden;
    margin-top: 10px;
    margin-bottom: 14px;
    box-shadow: 0px 7px 15px 1px rgba(6, 10, 82, 0.24);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .load-more {
    width: 100%;
    height: 36px;
    background-color: #ffffff;
    margin: 6px 0;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    color: #13227a;
    cursor: pointer;
    user-select: none;
    box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  }
}
</style>
